import React, { useEffect, useState } from "react";
import { Container, Row, Col, Image } from "react-bootstrap"
import { useDrop } from "react-dnd";
import DraggableContainer from "./DraggableContainer";
import dropFieldClassNames from "../../utils/dropFieldClassNames";
import Tooltip from "rc-tooltip";

// Constants
import colors from "../../utils/colors";
import items from "../../utils/items";

// Images
import factoryPlaceholder from "../../assets/images/factory-placeholder.png"
import machinePlaceholder from "../../assets/images/machine-placeholder.png"
import productPlaceholder from "../../assets/images/product-placeholder.png"

export default function DroppableField(props) {
	const [isHover, setIsHover] = useState(false);

	const [{ isOver, canDrop }, drop] = useDrop({
		accept: (props.containerType !== undefined) ? [items.container, props.containerType] : [items.container],
		collect: (monitor) => ({
			isOver: monitor.isOver(),
			canDrop: monitor.canDrop(),
		}),
		drop: (item) => {
			if (props.productionType) {
				props.appendContainer(props.productionType, item.coins, props.id, item.hasCard, item.cardValue, item.cardColor);
			} else if (props.kind === "Sales") {
				props.appendContainer(item.coins, props.id, item.hasCard, item.cardValue, item.cardColor);
			} else {
				props.appendContainer(item.coins, props.id, props.kind);
			}
			return item;
		},
	});

	const backgroundColor = isOver && canDrop ? colors.activeBackground : "";
	const opacity = props.design ? 0.5 : 1;
	const canPlayerDrop = drop;

	// Restored board state can contain null entries for some fields -
	// fall back to an empty object instead of crashing the whole board.
	const data = props.data || {};

	let showTooltip = data.isDragging && data.type === "CONTAINER" ? true : false;
	if (!showTooltip) {
		if (isHover && window.playerId) {
			showTooltip = true;
		}
	} else if (data.playerId === window.playerId) {
		showTooltip = false;
	}

	return (
		<>
			{data.hasContainer ? (
				<div
					className={props.class}
					onMouseEnter={() => setIsHover(true)}
					onMouseLeave={() => setIsHover(false)}
				>
					<Tooltip
						placement="topLeft"
						align={{
							offset: [0, 5],
						}}
						visible={showTooltip}
						overlay={
							<div style={{
								zIndex: 1000,
								display: "flex",
								flexDirection: "column",
							}}>
								<span style={{ fontSize: ".6rem" }}>{data.coins?.reduce((acc, coin) => acc + coin, 0)} Coins</span>
							</div>
						}
					>
						<DraggableContainer
							id={props.id}
							canEdit={props.canEdit}
							data={data}
							isHorizontal={props.isHorizontal}
							containerType={props.containerType}
							productionType={props.productionType}
							removeContainer={props.removeContainer}
							addCoin={props.addCoin}
							removeCoin={props.removeCoin}
							addCard={props.addCard}
							isDraggingHandler={props.isDraggingHandler}
							kind={props.kind}
							pinId={props.mainId}
						/>
					</Tooltip>
				</div>
			) : (
				<div
					className={props.class}
					style={{ backgroundColor: backgroundColor, opacity: opacity }}
					ref={canPlayerDrop}
				>
					{
						(props.productionType === "factory" && <div className="field-content">
							<Container>
								<Row className="field-content-image-row machine">
									<Col>
										<Image src={factoryPlaceholder} />
									</Col>
								</Row>
							</Container>
						</div>)
						||
						(props.productionType === "product" && <div className="field-content">
							<Container>
								<Row className="field-content-image-row product">
									<Col>
										<Image src={productPlaceholder} />
									</Col>
								</Row>
							</Container>
						</div>)
						||
						(props.productionType === "machine" && <div className="field-content">
							<Container>
								<Row className="field-content-image-row machine">
									<Col>
										<Image src={machinePlaceholder} />
									</Col>
								</Row>
							</Container>
						</div>)
					}
				</div>
			)}
		</>
	);
}
